// Single source of truth for all pipeline select options.
// Consumed by: StageCellEditor, PropertyDashboard, PipelineTabs directly, and utils.js's
// getStageFromStatus/getStatusLabel/getStageCounts (which is where the tab filter and the counts
// actually read it from).
//
// The stage list is spec'd in files/sow2/mr-11-stage-enum.md §1 — thirteen values as of mr-11, each
// cell traced to a source (letter 41's own "nine disappear, seven appear, six stay" arithmetic,
// letter 49's decision to put Sale Pending in Dispositions, spec/pipeline.md for in-group order).
// This used to be duplicated in config.js's PIPELINE_STAGES under a different group field name
// (`statuses` vs `options`) and drifted; that file is gone and this is the only literal list left.
//
// mr-16 (letter 66, 10.09.2026) dropped `contacted` and `demo` and relabeled `sale_pending`/`sold`
// to "Pending"/"Closed" (identifiers unchanged — Cong's Decision #1) — eleven values now, not
// thirteen.

// ── Stage ─────────────────────────────────────────────────────────────────────

export const ACQUISITION_OPTIONS = [
  { value: 'new_lead',        label: 'New Lead'       },
  { value: 'analyzing_deal',  label: 'Analyzing Deal' },
  { value: 'offer_sent',      label: 'Offer Sent'     },
  { value: 'negotiating',     label: 'Negotiating'    },
  { value: 'under_contract',  label: 'Under Contract' },
]

export const ACTIVE_OPTIONS = [
  { value: 'planning',           label: 'Planning'           },
  { value: 'under_construction', label: 'Under Construction' },
  { value: 'final_inspection',   label: 'Final Inspection'   },
]

export const DISPOSITION_OPTIONS = [
  { value: 'listed',        label: 'Listed'  },
  { value: 'sale_pending',  label: 'Pending' },
  { value: 'sold',          label: 'Closed'  },
]

export const STAGE_OPTIONS = [
  { key: 'acquisitions',  label: 'Acquisitions',  options: ACQUISITION_OPTIONS  },
  { key: 'projects',      label: 'Projects',       options: ACTIVE_OPTIONS       },
  { key: 'dispositions',  label: 'Dispositions',   options: DISPOSITION_OPTIONS  },
]

// The grid's Stage pill names the group in the singular ("Acquisition"), as the SOW 4 `pipeline`
// frame draws it; tabs and menu headings keep the plural labels above.
export const STAGE_PILL_GROUP_LABELS = {
  acquisitions: 'Acquisition',
  projects:     'Project',
  dispositions: 'Disposition',
}

// ── Strategy ──────────────────────────────────────────────────────────────────

export const RESALE_OPTIONS = [
  { value: 'fix_flip',   label: 'Fix & Flip' },
  { value: 'wholesale',  label: 'Wholesale'  },
  { value: 'wholetail',  label: 'Wholetail'  },
]

export const RENTAL_OPTIONS = [
  { value: 'brrrr',              label: 'BRRRR'             },
  { value: 'long_term_rental',   label: 'Long-Term Rental'  },
  { value: 'short_term_rental',  label: 'Short-Term Rental' },
]

export const CONSTRUCTION_OPTIONS = [
  { value: 'build_to_rent', label: 'Build to Rent' },
  { value: 'build_to_sell', label: 'Build to Sell' },
]

export const STRATEGY_OPTIONS = [
  { label: 'Resale',           options: RESALE_OPTIONS       },
  { label: 'Rental',           options: RENTAL_OPTIONS       },
  { label: 'New Construction', options: CONSTRUCTION_OPTIONS },
]
